import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="not-found-content">
      <div className="not-found-container">
        <div className="not-found-content">
          <div className="error-icon">404</div>
          <h1>Page Not Found</h1>
          <p>
            Sorry, the page you are looking for doesn't exist or has been moved.
          </p>
          <div className="error-actions">
            <button onClick={handleGoHome} className="primary-button">
              Go to Dashboard
            </button>
            <button onClick={handleGoBack} className="secondary-button">
              Go Back
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 